import React from "react";
import PropTypes from "prop-types";
import { clx } from "../../../utils/Helpers";
import "./UILanguageSkillBar.scss";

const DEFAULT_SEGMENTS = 5;

const PROFICIENCY_FILLED = {
  beginner: 1,
  elementary: 2,
  intermediate: 3,
  advance: 4,
  advanced: 4,
  fluent: 5,
  native: 5,
};

const resolveFilledSegments = (proficiency, segments) => {
  if (typeof proficiency === "number" && Number.isFinite(proficiency)) {
    return Math.min(segments, Math.max(0, proficiency));
  }

  const key = String(proficiency || "")
    .trim()
    .toLowerCase();

  if (PROFICIENCY_FILLED[key] != null) {
    return PROFICIENCY_FILLED[key];
  }

  return 0;
};

const resolveTone = (proficiency, proficiencyLabel) => {
  const key = String(proficiency || proficiencyLabel || "")
    .trim()
    .toLowerCase();

  return key.includes("native") ? "native" : "primary";
};

const UILanguageSkillBar = ({
  language,
  proficiency,
  proficiencyLabel,
  segments = DEFAULT_SEGMENTS,
  className,
}) => {
  const filled = resolveFilledSegments(proficiency, segments);
  const tone = resolveTone(proficiency, proficiencyLabel);
  const displayProficiencyLabel = proficiencyLabel || proficiency || "";

  return (
    <div
      className={clx(
        "ui-language-skill-bar",
        `ui-language-skill-bar--${tone}`,
        className,
      )}
    >
      <div className="ui-language-skill-bar__header">
        <span className="ui-language-skill-bar__language">{language}</span>
        {displayProficiencyLabel ? (
          <span className="ui-language-skill-bar__label">
            {displayProficiencyLabel}
          </span>
        ) : null}
      </div>
      <div
        className="ui-language-skill-bar__track"
        role="meter"
        aria-valuemin={0}
        aria-valuemax={segments}
        aria-valuenow={filled}
        aria-label={language}
      >
        {Array.from({ length: segments }, (_, index) => (
          <span
            key={index}
            className={clx(
              "ui-language-skill-bar__segment",
              index < filled && "ui-language-skill-bar__segment--filled",
            )}
          />
        ))}
      </div>
    </div>
  );
};

UILanguageSkillBar.propTypes = {
  language: PropTypes.string.isRequired,
  proficiency: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  proficiencyLabel: PropTypes.string,
  segments: PropTypes.number,
  className: PropTypes.string,
};

UILanguageSkillBar.defaultProps = {
  proficiency: "",
  proficiencyLabel: "",
  segments: DEFAULT_SEGMENTS,
  className: "",
};

export default UILanguageSkillBar;
